<template>
  <div class="noauthority of">
    <div class="authority-bg"></div>
    <div class="authority-txt">
        抱歉...当前您没有访问权限，请联系管理员
    </div>
    <el-button icon="el-icon-refresh" size="mini" class="authority-btn" @click="$router.go(-2)">返回上一页</el-button>
    <el-button icon="el-icon-home" size="mini" class="authority-btn" @click="$router.push({path: '/pages'})">返回首页</el-button>
    <a href="javascript:void(0)" @click="$router.go(-2)" class="router-link-exact-active">返回上一页</a>
    <router-link :to="{path: '/pages'}">返回首页</router-link>
  </div>
</template>

<script>
  export default {
    name: "Forbidden403View"
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/403View.vue